import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IErrorMessageSetter } from '../app.tokens';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService implements IErrorMessageSetter {
  readonly errorMessageHeading = new BehaviorSubject<string>('');
  readonly errorMessage = new BehaviorSubject<string>('');
}
